import { AnyAction } from "redux";
import * as constants from "../constants/succes.constants";

export const hideSuccessNotification = (): AnyAction => ({
  type: constants.ON_SUCCESS_NOTIFICATION_HIDE,
});
